/* AIH — tiny, dependency-free slideshow controller for the AIH Hero.
   Markup contract:
     <div data-aih-slideshow data-autoplay="6000">
       <div class="aih-hero__slides"> <div class="aih-hero__slide [is-active]">…</div> … </div>
       <button data-aih-prev> <button data-aih-next>
       <div class="aih-hero__dots"> <button class="aih-hero__dot [is-active]" data-aih-dot="0"> … </div>
     </div>
   Single-slide heroes render fine without any of this. Respects reduced-motion. */
(function () {
  function initSlideshow(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.aih-hero__slide'));
    if (slides.length <= 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.aih-hero__dot'));
    var prev = root.querySelector('[data-aih-prev]');
    var next = root.querySelector('[data-aih-next]');
    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) index = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
    }
    function go(i) { show(i); restart(); }
    function restart() {
      if (!delay || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, delay);
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-aih-dot'), 10) || 0); });
    });

    // pause on hover, basic swipe
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    show(index);
    restart();
  }

  function initAll() {
    document.querySelectorAll('[data-aih-slideshow]').forEach(initSlideshow);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-aih-slideshow]').forEach(initSlideshow);
  });
})();
